import { apiClient, type UserApi } from 'modules/api-client';
import { BaseCard, Spinner } from 'modules/design-system';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthBaseCardHeader } from '../../../components/AuthBaseCardHeader/AuthBaseCardHeader';
import {
  InvalidToken,
  ResetForm,
} from '../../../components/ResetForm/ResetForm';

type ResetPasswordFormProps = {
  token: string;
  email: string;
  onSuccess: (user: UserApi) => void;
};

export const ResetPasswordForm = ({
  email,
  token,
  onSuccess,
}: ResetPasswordFormProps) => {
  const [t] = useTranslation('user');
  const [isResetTokenValid, setIsResetTokenValid] = useState<
    boolean | 'not-validated-yet'
  >('not-validated-yet');

  useEffect(() => {
    if (email && token) {
      apiClient.user
        .validateResetToken(email, token)
        .then((response) => {
          setIsResetTokenValid(response.success);
        })
        .catch(() => {
          setIsResetTokenValid(false);
        });
    }
  }, [email, token]);

  return (
    <BaseCard>
      <AuthBaseCardHeader title={t('user.resetPassword.form.header')} />
      {isResetTokenValid === 'not-validated-yet' ? (
        <Spinner />
      ) : isResetTokenValid === true ? (
        <ResetForm email={email} token={token} onSuccess={onSuccess} />
      ) : (
        <InvalidToken />
      )}
    </BaseCard>
  );
};
